/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
export default function SocialFollowSection({ storeData, theme }) {
  if (!storeData?.social) return null;
  const TikTokIcon = ({ size = 28, color = "#FFFFFF" }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M33.5 4c.9 7.3 6.1 11.6 13.5 11.9v7.5c-4.1.2-7.7-1-11.1-3.1v14.7c0 7.3-6 13.3-13.3 13.3S9.3 42.3 9.3 35s6-13.3 13.3-13.3c.9 0 1.8.1 2.6.3v7.7c-.8-.3-1.6-.5-2.6-.5-3.1 0-5.6 2.5-5.6 5.6s2.5 5.6 5.6 5.6 5.6-2.5 5.6-5.6V4h7.3z" />
    </svg>
  );

  const socials = [
    {
      key: "facebook",
      label: "فيسبوك",
      icon: "fab fa-facebook-f",
      url: storeData.social.facebook,
      color: "#1877F2"
    },
    {
      key: "instagram",
      label: "إنستغرام",
      icon: "fab fa-instagram",
      url: storeData.social.instagram,
      color: "#E4405F"
    },
    {
      key: "snapchat",
      label: "سناب شات",
      icon: "fab fa-snapchat-ghost",
      url: storeData.social.snapchat,
      color: "#FFFC00"
    },
    {
      key: "tiktok",
      label: "تيك توك",
      url: storeData.social.tiktok,
      renderIcon: () => (
        <TikTokIcon size={26} color={theme.accent} />
      )
    }

  ].filter(s => s.url); // ✅ فقط الموجود

  if (socials.length === 0) return null;

  return (
    <section
      className="border-t py-12"
      style={{
        backgroundColor: "rgba(0,0,0,0.35)",
        borderColor: "rgba(255,255,255,0.1)"
      }}
    >
      <div className="max-w-6xl mx-auto px-4 text-center">
        <h3 className="text-xl text-white mb-2">
          تابِعنا على مواقع التواصل ✨
        </h3>
        <p className="text-sm text-white/60 mb-8">
          كون على اطلاع بآخر العروض والمنتجات الجديدة
        </p>

        <div className="flex justify-center gap-4 flex-wrap">
          {socials.map(s => (
            <a
              key={s.key}
              href={s.url}
              target="_blank"
              rel="noreferrer"
              className="flex flex-col items-center gap-2 px-6 py-4 rounded-2xl border transition-all"
              style={{
                background: "rgba(0,0,0,0.4)",
                borderColor: "rgba(255,255,255,0.1)",
                minWidth: "120px"
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = theme.accent;
                e.currentTarget.style.transform = "translateY(-4px)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              {s.renderIcon ? (
                s.renderIcon()
              ) : (
                <i
                  className={`${s.icon} text-2xl`}
                  style={{ color: s.color || theme.accent }}
                />
              )}

              <span
                className="text-xs font-semibold"
                style={{ color: theme.accent }}
              >
                {s.label}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
